import { ScrollView, Image} from 'react-native';
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from '@app/theme';
import Button from '@app/sharedComponents/Button/Button';
import { useEffect, useRef, useState } from 'react';
import { PrivateStackParamList } from '@app/navigationApp/types';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import ROUTE from '@app/navigationApp/routes';
import { formatIndianCurrency } from '@app/utils/utility';
import { useAppSelector } from '@app/store/hooks';
import dayjs from 'dayjs';
import Stepper from '../../../assets/Icons/StepperInProgress'
import Right from '../../../assets/Icons/Right'
import fetchUserDetails from '@app/helper/fetchUserInfo';
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import AccountOpeningInfo from '../ConfirmWithdrawAmount/components/AccountOpeningInfo';
import { Info } from '@app/sharedComponents/Icons/Icons';
type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'WITHDRAW_SUCCESS'>;

const WithdrawalSuccess = ({navigation,route}:ScreenProps) =>{
    const {successData,isNotFirstDisbursal} = route.params || {};
    const {amount,remark,expectedTransferBy,createdOn,disbursalAdditionalDetails} = successData || {};
    const {netDisbursalAmount,accountOpeningFee,processingFee,stampDutyFee,gstOnProcessingFee,lienMarkingFee}= disbursalAdditionalDetails || {};
    const [buttonLoader, setButtonLoader] = useState(false);
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);

    const {accountNumber,bankName,bankCode} = useAppSelector((state) => state.auth.userProfile?.bankDetails);
    useEffect(()=>{ 
        fetchUserDetails()
    },[])

    const closeBottomSheet = () => {
        setIsBottomSheetVisible(false);
    };

    const onDone = () =>{
        setButtonLoader(true);
        setTimeout(() => {
            navigation.navigate(ROUTE.HOME);
            setButtonLoader(false);
        }, 2000);
    }
    return(
        <>
        <ScrollView contentContainerStyle={{flexGrow: 1, padding:16, backgroundColor:themeColorSet['bg-fill-primary']}}>
            <ThemedView mt='xl' borderWidth={1} borderColor='border-primary' borderRadius='sm' backgroundColor='bg-fill-primary'>
                <ThemedView p='lg'>
                    <ThemedText variant='b3r' color='text-secondary' mb='xs' >Withdrawal request received</ThemedText>
                    <ThemedView flexDirection='row' alignItems='center'>
                    <ThemedText variant='l1' color='text-primary'>₹</ThemedText>
                    <ThemedText variant='h1b' color='text-primary'>{formatIndianCurrency(amount)}</ThemedText>
                    </ThemedView>
                    
                    {successData?.disbursalAdditionalDetails?.accountOpeningFee >0 &&
                    <ThemedView backgroundColor='bg-fill-secondary' p='md' borderRadius='sm' my='lg'>
                        <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center'>
                            <ThemedView flexDirection='row' alignItems='center'>
                                <ThemedText variant='b3r' color='text-primary'>{isNotFirstDisbursal ? "Outstanding charges ":"Account opening fee(incl. GST) " }</ThemedText>
                                {!isNotFirstDisbursal &&
                                <ThemedPressable onPress={()=>setIsBottomSheetVisible(true)}>
                                    <Info size={16}/>
                                </ThemedPressable>}
                            </ThemedView>
                            <ThemedText variant='b3r' color='text-primary'>₹{formatIndianCurrency(accountOpeningFee)}</ThemedText>
                        </ThemedView>
                        <ThemedView height={1} backgroundColor='border-primary' width={'100%'} my='lg' />
                        <ThemedView flexDirection='row' justifyContent='space-between' alignItems='center'>
                            <ThemedText variant='b3r' color='text-primary'>Net disbursal amount</ThemedText>
                            <ThemedText variant='b3r' color='text-primary'>₹{formatIndianCurrency(netDisbursalAmount)}</ThemedText>
                        </ThemedView>
                    </ThemedView>}
                </ThemedView>
                <ThemedView height={1} backgroundColor='border-primary' width={'100%'} mb='2xl' />
                <ThemedView mx='lg' mb="lg">
                    <ThemedView flexDirection='row' mb="4xl" position="relative">
                        {/* Vertical progress line */}
                        <ThemedView
                            position="absolute"
                            left={15}
                            top={32}
                            width={2}
                            height={60}
                            backgroundColor="border-primary"
                            zIndex={-1}
                            borderRadius="full"
                        />
                        <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center" zIndex={1000}>
                            <ThemedView backgroundColor="bg-surface-primary" width={24} height={24} borderRadius="full" justifyContent="center" alignItems="center">
                                <Right size={16} color="#2D57D9"/>
                            </ThemedView>
                        </ThemedView>
                        <ThemedView ml='sm'>
                            <ThemedText variant='b3s' color='text-disabled'>Withdrawal request received</ThemedText>
                            <ThemedText variant='b4r' color='text-secondary'>Placed on {dayjs(createdOn).format('h:mm A, DD-MMM')}</ThemedText>  
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flexDirection='row' > 
                        <Stepper/>
                        <ThemedView  ml='sm'>
                            <ThemedText variant='b3s' color='text-primary'>Expected transfer by</ThemedText>
                            <ThemedText variant='b4r' color='text-primary'>{dayjs(expectedTransferBy).format('h:mm A, DD-MMM')} </ThemedText>  
                        </ThemedView>
                    </ThemedView>
                </ThemedView>
               {remark && 
                <ThemedView flexDirection='row' flexWrap='wrap' flex={1} backgroundColor='bg-fill-warning' p="md" mx='lg' borderRadius='sm' >
                    <ThemedText variant='b4r' color='text-primary'>{remark} </ThemedText>
                    {/* <ThemedText variant='b4b' color='text-primary'> 16 Dec</ThemedText> */}
                </ThemedView>
                }
                <ThemedView m="lg">
                    <ThemedView height={1} backgroundColor='border-primary' width={'100%'}  />
                </ThemedView>
                <ThemedView flexDirection='row' alignItems='center' mb="lg" mx="lg">
                    <Image
                        source={{uri:`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode??'default'}.png`}}
                        style={{width: 40, height: 40}}
                    />
                    <ThemedText variant='b4r' color='text-primary' ml="sm">To {bankName} xxxx {accountNumber.toString().slice(-4)}</ThemedText>
                </ThemedView>
            </ThemedView>
        </ScrollView>
        <ThemedView height={1} backgroundColor='border-primary' width={'100%'} />
        <ThemedView backgroundColor='bg-fill-primary'  p="lg" >
        <Button
          eventName={route?.name + '_CONTINUE'}
          label={'Done'}
          handlePress={onDone}
          type={'SOLID'}
          size='MD'
          buttonLoader={buttonLoader}
        />
        </ThemedView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containerStyle={{ backgroundColor: '#fefefe' }}
        >
        <AccountOpeningInfo 
            accountOpeningFee={accountOpeningFee}
            closeBottomSheet={closeBottomSheet}
            processingFee={processingFee}
            gstOnProcessingFee={gstOnProcessingFee}
            stampDutyFee={stampDutyFee}
            lienMarkingFee={lienMarkingFee}
        />
        </BottomSheetContainer>
      </>

    )
}

export default WithdrawalSuccess;